/**
 * The WebGL contexts the game holds right now, by label (M33): the main canvas, the end screen's chest, Captain Bram,
 * the skins turntable and thumbnails. iOS counts every context's memory against the page, so the crash breadcrumb
 * (infra/breadcrumbs.ts) and Settings → Copy diagnostics say how many were alive. No imports: anything can register.
 */
const live = new Map<number, string>();
let next = 1;

export const glContexts = {
  /** A context was made; call the returned function when it is given back (forceContextLoss / dispose). Idempotent. */
  open(label: string): () => void {
    const id = next++;
    live.set(id, label);
    return () => { live.delete(id); };
  },
  /** The labels of the contexts alive now, in the order they were made. */
  labels(): string[] { return [...live.values()]; },
  get count(): number { return live.size; },
};
